<template>
  <!--首页-->
  <div class="all-page" style="">
    <!--banner-->
    <div class="banner-box">
      <div v-if="isShowInitBanner" class="init-banner">
        <el-carousel
          :interval="5000"
          arrow="always"
          loop
          :autoplay="true"
          indicator-position="none"
          :height="bannerH - 6 + 'vw'"
        >
          <!-- <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_init1.png"
            />
          </el-carousel-item> -->
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_new_init.jpg"
              @click="outerHrefOpen('https://www.ule.com/event/2017/0307/luckcard.html')"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_init2.jpg"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_init3.png"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_new_init.jpg"
              @click="outerHrefOpen('https://www.ule.com/event/2017/0307/luckcard.html')"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_init2.jpg"
            />
          </el-carousel-item>
          <el-carousel-item>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/banner_init3.png"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <el-carousel
        :interval="5000"
        arrow="always"
        @change="bannerChange"
        loop
        :autoplay="false"
        indicator-position="none"
        :height="bannerH + 'vw'"
        ref="homeCarousel"
      >
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner01_new.png"
            @click="innerHrefOpen('yzg')"
          />
          <div class="dataVal-box screen01">
            <span class="num-box"
              ><ScrollNumber :val="screen01.one"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen01.two"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen01.three"></ScrollNumber
            ></span>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner02.png"
            @click="innerHrefOpen('yznp')"
          />
          <div class="dataVal-box screen02">
            <span class="num-box"
              ><ScrollNumber :val="screen02.one"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen02.two"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen02.three"></ScrollNumber
            ></span>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner03_new.png"
            @click="innerHrefOpen('ylsc')"
          />
          <div class="dataVal-box screen03">
            <span class="num-box"
              ><ScrollNumber :val="screen03.one"></ScrollNumber
              ><span class="unit">个</span></span
            >
            <span class="num-box"
              ><ScrollNumber :val="screen03.two"></ScrollNumber
              ><span class="unit"
                >亿<span class="unit-plus">+</span></span
              ></span
            >
            <!-- <span class="num-box"
              ><ScrollNumber :val="screen03.three"></ScrollNumber
            ></span> -->
          </div>
          <!-- 各省特产 -->
          <div class="specialties-box">
            <div
              v-for="(item, idx) in specialties"
              :key="idx"
              class="specialty-item"
              :style="{ top: item.top, left: item.left }"
            >
              <el-popover
                placement="top"
                trigger="hover"
                :visible-arrow="false"
                popper-class="specialties-popover"
              >
                <div class="img-wraper" slot="reference">
                  <img
                    :src="
                      `https://i0.ulecdn.com/sites/ule/img/home/new/specialties/${item.name}.png`
                    "
                    alt=""
                  />
                </div>
                <div class="popper-content">
                  <div class="title">
                    {{ item.title }}
                  </div>
                  <ul>
                    <li v-for="(item2, idx2) in item.value" :key="idx2">
                      {{ item2 }}基地
                    </li>
                  </ul>
                </div>
                <i></i>
              </el-popover>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner04.png"
            @click="innerHrefOpen('ylxd')"
          />
          <div class="dataVal-box screen04">
            <span class="num-box"
              ><ScrollNumber :val="screen04.one"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen04.two"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen04.three"></ScrollNumber
            ></span>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner05_new.png"
            @click="innerHrefOpen('ylzb')"
          />
          <!-- <div class="dataVal-box screen05">
            <span class="num-box"
              ><ScrollNumber :val="screen05.one"></ScrollNumber
            ></span>
            <span class="num-box">数百</span>
          </div> -->
          <div class="liveshow-box">
            <div class="iframe-wraper">
              <iframe
                :src="controlActive == 5 ? 'https://h5.ule.com/broadcast/broadLive/11564/204190' : ''"
                frameborder="0"
              ></iframe>
            </div>
            <img
              src="https://i0.ulecdn.com/sites/ule/img/home/new/bg_phone.png"
              alt=""
            />
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner06_new.png"
            @click="innerHrefOpen('ylyx')"
          />
          <div class="dataVal-box screen06">
            <span class="num-box"
              ><ScrollNumber :val="screen06.one"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen06.two"></ScrollNumber
            ></span>
            <span class="num-box">数</span>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner07.png"
            @click="innerHrefOpen('ysh')"
          />
          <div class="dataVal-box screen07">
            <span class="num-box"
              ><ScrollNumber :val="screen07.one"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen07.two"></ScrollNumber
            ></span>
            <span class="num-box"
              ><ScrollNumber :val="screen07.three"></ScrollNumber
            ></span>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner08.png"
            @click="innerHrefOpen('wlcx')"
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="https://i0.ulecdn.com/sites/ule/img/home/new/banner010.png"
            @click="innerHrefOpen('saas')"
          />
        </el-carousel-item>
      </el-carousel>
      <div class="control-box">
        <div
          v-for="(item, idx) in controls"
          :key="idx"
          :style="{ background: item.background }"
          :class="[
            'control-item',
            `control-item-${idx + 1}`,
            controlActive == idx + 1 ? 'active' : ''
          ]"
          @mouseenter="onControlMouseenter(idx + 1)"
        >
          <img
            :src="
              `https://i0.ulecdn.com/sites/ule/img/home/new/tab0${idx + 1}_new${
                controlActive == idx + 1 ? '_on' : ''
              }.png`
            "
            alt=""
          />
          <div class="text">
            <p class="title">{{ item.title }}</p>
            <p
              v-show="controlActive == idx + 1"
              v-html="item.content"
              class="content"
            ></p>
          </div>
        </div>
      </div>
    </div>
    <div class="h36"></div>
    <div v-if="showDialog919" class="dialog-919">
      <div class="dialog-master"></div>
      <div class="dialog-inner">
        <template v-if="showCountdown">
          <img :src="activeInfo919.imgUrlPc1" alt="" />
          <div class="text-box">
            <div class="tips">
              大促将于<span>{{ countdownDate }}</span
              >开始
            </div>
            <div class="countdown-box">
              <el-statistic
                :value="deadline"
                time-indices
                title=""
                format="HH:mm:ss"
                @change="onTimeChange"
                @finish="onCountdownFinish"
              >
                <template slot="formatter">
                  <div class="countdown-time">
                    <div class="hh time">
                      <span>{{ countdownTime[0] }}</span>
                      <span>{{ countdownTime[1] }}</span>
                    </div>
                    <i>:</i>
                    <div class="mm time">
                      <span>{{ countdownTime[2] }}</span>
                      <span>{{ countdownTime[3] }}</span>
                    </div>
                    <i>:</i>
                    <div class="ss time">
                      <span>{{ countdownTime[4] }}</span>
                      <span>{{ countdownTime[5] }}</span>
                    </div>
                  </div>
                </template>
              </el-statistic>
              <p class="label">倒计时</p>
            </div>
          </div>
        </template>
        <template v-else>
          <img :src="activeInfo919.imgUrlPc2" alt="" class="img-919" />
        </template>
        <Icon
          type="close-round"
          size="32"
          color="#fff"
          :class="{ img919: !showCountdown }"
          @click="showDialog919 = false"
        ></Icon>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/util/request";
import ScrollNumber from "../components/scrollNum.vue";
import { provSpecialties } from "@/util/localData";
import store from "@/vuex/store";
import { mapState, mapMutations } from "vuex";
import { getDomain } from "@/util/common";
export default {
  name: "Home",
  store,
  data() {
    return {
      showDialog919: false,
      showCountdown: false,
      deadline: "",
      countdownTime: [0, 0, 0, 0, 0, 0],
      countdownDate: "",
      isShowInitBanner: true,
      bannerVal: 0,
      autoplaySpeed: 3000,
      bannerH: 42.4,
      screen01: {
        one: 35.5,
        two: 40,
        three: 2
      },
      screen02: {
        one: 0,
        two: 0,
        three: 0
      },
      screen03: {
        one: 0,
        two: 0,
        three: 0
      },
      screen04: {
        one: 0,
        two: 0,
        three: 0
      },
      screen05: {
        one: 0,
        two: 0,
        three: 0
      },
      screen06: {
        one: 0,
        two: 0,
        three: 0
      },
      screen07: {
        one: 0,
        two: 0,
        three: 0
      },
      specialties: provSpecialties,
      controls: [
        {
          title: "邮掌柜",
          background: "#FFF6F2",
          content: "乡村振兴数字商业推动者"
        },
        {
          title: "邮政农品",
          background: "#F3FFF2",
          content: "中国邮政名优特产溯源<br />品牌"
        },
        {
          title: "邮乐商城",
          background: "#FCFEF1",
          content: "中国邮政旗下电商平台"
        },
        {
          title: "邮乐小店",
          background: "#FFF6F2",
          content: "社群营销平台"
        },
        {
          title: "邮乐直播",
          background: "#F5F3FF",
          content: "全国特色农品直播平台"
        },
        {
          title: "邮乐优鲜",
          background: "#F3FFF4",
          content: "一站式社区团购平台"
        },
        {
          title: "邮生活",
          background: "#E6F2F2",
          content: "中国邮政会员服务平台"
        },
        {
          title: "物流服务",
          background: "#EFFBF0",
          content: "连接中国邮政物流"
        },
        {
          title: "SAAS服务平台",
          background: "#F2FFFF",
          content: "新零售产品解决方案"
        }
      ],
      controlActive: 1
    };
  },
  computed: {
    ...mapState(["isIn919", "activeInfo919"])
  },
  created() {},
  mounted() {
    if(this._isMobile()){
      window.location = (`http://www.${getDomain()}ule.com/m/`);
    }
    let that = this;
    $(".el-carousel__indicators").hover(function() {
      that.isShowInitBanner = false;
    });
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    onTimeChange(value) {
      const h = Math.floor(value / 1000 / 60 / 60) + "";
      const m = Math.floor((value - h * 1000 * 60 * 60) / 1000 / 60) + "";
      const s =
        Math.floor((value - h * 1000 * 60 * 60 - m * 60 * 1000) / 1000) + "";
      const rValue = [
        h.length > 1 ? h[0] : "0",
        h.length > 1 ? h[1] : h,
        m.length > 1 ? m[0] : "0",
        m.length > 1 ? m[1] : m,
        s.length > 1 ? s[0] : "0",
        s.length > 1 ? s[1] : s
      ];
      this.countdownTime = rValue;
    },
    onCountdownFinish() {
      this.showCountdown = false;
    },
    innerHrefOpen(path) {
      let originName = location.origin;
      path = `${originName}${this.$basePath}/${path}`;
      window.open(path);
    },
    outerHrefOpen(path) {
      window.open(path);
    },
    onControlMouseenter(subTab) {
      this.isShowInitBanner = false;
      this.controlActive = subTab;
      this.$refs.homeCarousel.setActiveItem(subTab - 1);
    },
    bannerChange(value, oldValue) {
      this.controlActive = value + 1;
      this.screen01 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen02 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen03 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen03 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen04 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen05 = {
        one: 0,
        two: "数百"
      };
      this.screen06 = {
        one: 0,
        two: 0,
        three: 0
      };
      this.screen07 = {
        one: 0,
        two: 0,
        three: 0
      };

      if (value == 0) {
        this.screen01 = {
          one: 35.5,
          two: 40,
          three: 2
        };
      } else if (value == 1) {
        this.screen02 = {
          one: 100,
          two: 1000,
          three: 10000
        };
      } else if (value == 2) {
        this.screen03 = {
          one: 1000,
          two: 1.6,
          three: 50
        };
      } else if (value == 3) {
        this.screen04 = {
          one: 300,
          two: 1395,
          three: 2
        };
      } else if (value == 4) {
        this.screen05 = {
          one: 10,
          two: "数百"
        };
      } else if (value == 5) {
        this.screen06 = {
          one: 100,
          two: 5,
          three: 2
        };
      } else if (value == 6) {
        this.screen07 = {
          one: 1.46,
          two: 7600,
          three: 900
        };
      }
    }
  },
  components: {
    ScrollNumber
  },
  watch: {
    screen01: {
      handler(newVal, oldVal) {
        console.log(newVal, oldVal);
      },
      deep: true,
      immediate: true
    },
    isIn919: {
      handler(value) {
        if (value && value != 'false') {
          this.showDialog919 = true;
        }
      },
      immediate: true
    },
    activeInfo919: {
      handler(customAttribute) {
        if (customAttribute) {
          const {
            countdownTime1,
            countdownTime2,
            imgUrlPc1,
            imgUrlPc2
          } = customAttribute;
          if (
            countdownTime1 &&
            new Date(countdownTime1).getTime() > new Date().getTime()
          ) {
            // 倒计时
            this.showCountdown = true;
            this.deadline = new Date(countdownTime1).getTime();
            this.countdownDate = `${new Date(countdownTime1).getMonth() +
              1}月${new Date(countdownTime1).getDate()}日`;
          }
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped>
.all-page {
  background-color: #fff;
  .h36 {
    height: 36px;
  }
}
.banner-box {
  // background: RGBA(58, 66, 12, 1);
  position: relative;
  .init-banner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 999;
  }

  /deep/.el-carousel {
    overflow: hidden;
    .el-carousel__container {
    }

    // .el-carousel__arrow {
    //   width: 48px;
    //   height: 60px;
    //   border-radius: 0;
    //   &.el-carousel__arrow--left {
    //     background: url(https://i0.ulecdn.com/sites/ule/img/home/new/icon-left-arr.png) no-repeat center center;
    //     left: 209px;
    //   }
    //   &.el-carousel__arrow--right {
    //     background: url(https://i0.ulecdn.com/sites/ule/img/home/new/icon-right-arr.png) no-repeat center center;
    //     right: 209px;
    //   }
    //   .ivu-icon  {
    //     display: none;
    //   }
    // }
    .el-carousel__item {
      img {
        display: block;
        width: 100%;
        cursor: pointer;
      }
      .dataVal-box {
        position: absolute;
        font-size: 2.8vw;
        font-family: Arial, Helvetica, sans-serif;
        &.screen01 {
          top: 18.3vw;
          left: 19.6vw;
          color: #fb3131;
          .num-box:nth-of-type(2) {
            padding-left: 4vw;
          }
          .num-box:nth-of-type(3) {
            padding-left: 6vw;
          }
        }

        &.screen02 {
          top: 21.7vw;
          left: 19.9vw;
          color: #429709;
          .num-box:nth-of-type(2) {
            padding-left: 2.5vw;
          }
          .num-box:nth-of-type(3) {
            padding-left: 2.2vw;
          }
        }

        &.screen03 {
          top: 18vw;
          left: 19.8vw;
          color: #ff8a0d;
          .num-box {
            padding-right: 1vw;
            .unit {
              position: absolute;
              right: 9.8vw;
              top: 1.5vw;
              font-size: 0.8vw;
              font-weight: bold;
            }
            &:nth-of-type(2) {
              padding-left: 4.6vw;
              .unit {
                position: absolute;
                right: -0.1vw;
                top: 1.5vw;
                font-size: 0.8vw;
                font-weight: bold;
                .unit-plus {
                  position: absolute;
                  right: -0.5vw;
                  top: -0.5vw;
                }
              }
            }
          }

          // .num-box:nth-of-type(3) {
          //   padding-left: 6.1vw;
          // }
        }

        &.screen04 {
          top: 18.1vw;
          left: 21vw;
          color: #f18532;
          .num-box:nth-of-type(2) {
            padding-left: 3.4vw;
          }
          .num-box:nth-of-type(3) {
            padding-left: 4.6vw;
          }
        }

        &.screen05 {
          top: 15.5vw;
          left: 46.8vw;
          color: #ef3b39;
          .num-box:nth-of-type(2) {
            //padding-left: 1.5vw;
            font-size: 2vw;
            font-weight: normal;
            position: relative;
            top: 2.6vw;
            left: -16.7vw;
          }
        }

        &.screen06 {
          top: 18.3vw;
          left: 22.3vw;
          color: #ed3505;
          .num-box:nth-of-type(2) {
            padding-left: 4.8vw;
          }
          .num-box:nth-of-type(3) {
            padding-left: 4.5vw;
            font-size: 2.4vw;
            font-weight: normal;
            position: relative;
            top: -1vw;
          }
        }

        &.screen07 {
          top: 18.6vw;
          left: 20.8vw;
          color: #1ca9a7;
          .num-box:nth-of-type(2) {
            padding-left: 3.1vw;
          }
          .num-box:nth-of-type(3) {
            padding-left: 3.4vw;
          }
        }
      }
      .liveshow-box {
        position: absolute;
        width: 26vw;
        height: 52vw;
        top: 11vw;
        left: 63.3vw;
        overflow: hidden;
        transform-origin: 0% 0%;
        transform: scale(0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        .iframe-wraper {
          width: 92%;
          height: 98%;
          overflow: hidden;
          border-radius: 2vw;
          iframe {
            width: 100%;
            height: 100%;
            margin-top: 2%;
          }
        }
        img {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none;
        }
      }
    }
    // .el-carousel__indicators {
    //   width: 100%;
    //   height: 7.2vw;
    //   //display: none;

    //   &.el-carousel__indicators--horizontal {
    //     bottom: 0px;
    //     li {
    //       width: 10.41%;
    //       height: 7.2vw;
    //       transition: all 0.5s ease-in-out;
    //       &:nth-of-type(1) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab01.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(2) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab02.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(3) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab03.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(4) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab04.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(5) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab05.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(6) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab06.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(7) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab07.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(8) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab08.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       &:nth-of-type(9) {
    //         background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab010.png")
    //           no-repeat center center;
    //         background-size: cover;
    //       }
    //       margin: 0;
    //       padding: 0;
    //       background: #fff;
    //       button {
    //         opacity: 0;
    //         //width: 197px;
    //         width: 100%;
    //         //height: 140px;
    //         //background: #F2F2F2;
    //       }
    //       &.is-active {
    //         width: 16.72%;
    //         &:nth-of-type(1) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab01-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(2) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab02-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(3) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab03-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(4) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab04-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(5) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab05-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(6) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab06-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(7) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab07-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(8) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab08-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         &:nth-of-type(9) {
    //           background: url("https://i0.ulecdn.com/sites/ule/img/home/new/tab010-on.png")
    //             no-repeat center center;
    //           background-size: cover;
    //         }
    //         button {
    //           //width: 320px;
    //           width: 100%;
    //           background: #d60a08;
    //         }
    //       }
    //     }
    //   }
    // }
  }

  .control-box {
    width: 100%;
    height: 6vw;
    position: absolute;
    left: 0;
    top: 36.4vw;
    z-index: 100;
    display: flex;
    .control-item {
      width: 10.41%;
      height: 100%;
      transition: all 0.3s ease-in-out;
      display: flex;
      opacity: 0.9;
      backdrop-filter: blur(4px);
      overflow: hidden;
      cursor: pointer;
      img {
        height: 100%;
        width: 4.576vw;
        transition: all 0.3s ease-in-out;
      }
      &.active {
        width: 16.72%;
        img {
          width: 5.6vw;
          height: 100%;
        }
        .text {
          .title {
            font-size: 1.248vw;
          }
        }
      }
      .text {
        width: 11vw;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 0.5vw;
        padding-right: 0.2vw;

        .title {
          color: #333;
          font-size: 1.04vw;
          font-weight: bold;
        }
        .content {
          font-size: 0.832vw;
          color: #7d7d7d;
          margin-top: 0.15vw;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }

  .trait-box {
    position: absolute;
    left: 50%;
    bottom: 39px;
    width: 1192px;
    height: 120px;
    margin-left: -596px;
    overflow: hidden;
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      li {
        width: 298px;
        height: 120px;
        color: #222222;
        .icon-box {
          position: relative;
          width: 298px;
          height: 120px;
          img {
            display: block;
            width: 100%;
            height: 100%;
          }
          span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            line-height: 120px;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            text-shadow: 0px 6px 32px #000000;
          }
        }
      }
    }
  }
}

.specialties-box {
  position: absolute;
  width: 45vw;
  height: 30vw;
  left: 45vw;
  top: 5vw;
  .specialty-item {
    position: absolute;
    .img-wraper {
      width: 2.2vw !important;
      height: 2.2vw !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.dialog-919 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  .dialog-master {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.65);
  }
  .dialog-inner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -55%);
    img {
      width: 616px;
      height: 740px;
      &.img-919 {
        // width: 750px;
        // height: 430px;
        width: 900px;
        height: 516px;
      }
    }
    .text-box {
      position: absolute;
      bottom: 20px;
      width: 100%;
      height: 250px;
      padding-right: 15px;
      .tips {
        color: #a22525;
        font-size: 26px;
        padding-top: 50px;
        text-align: center;
        span {
          color: #fff;
        }
      }
      .countdown-box {
        margin-top: 30px;
        .countdown-time {
          display: flex;
          align-items: center;
          i {
            display: inline-block;
            font-style: normal;
            padding: 0 5px;
          }
          .time {
            display: flex;

            span {
              display: inline-block;
              background: #a22525;
              padding: 16px 12px;
              color: #fff;
              border-radius: 5px;
              font-size: 22px;
              &:nth-child(n + 2) {
                margin-left: 5px;
              }
            }
          }
        }
        .label {
          color: #fff;
          text-align: center;
          font-size: 24px;
          margin-top: 20px;
        }
      }
    }
    /deep/ .ivu-icon-close-round {
      position: absolute;
      top: 40px;
      right: 10px;
      cursor: pointer;
      &.img919 {
        top: -40px;
        right: -40px;
      }
    }
  }
}
</style>
<style lang="less">
.specialties-popover {
  background: #ecf8ec;
  border: 1px solid #64dcc5;
  border-radius: 10px 30px 10px 10px;
  position: relative;
  transform: translate(6px, -5px);
  padding: 10px 5px 5px;
  z-index: 9999 !important;
  min-width: 165px;
  .el-popover__title {
    display: none;
  }
  i {
    display: inline-block;
    position: absolute;
    background: url("https://i0.ulecdn.com/sites/ule/img/home/new/pop_bg.png")
      no-repeat center / 100% 100%;
    width: 130px;
    height: 19px;
    bottom: -18px;
    left: 6.5%;
  }
  &[x-placement="bottom"] {
    transform: translate(6px, 5px);
    i {
      top: -18px;
      transform: rotate(180deg);
    }
  }
  .popper-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: 18px;
      width: 130px;
      height: 34px;
      background: url("https://i0.ulecdn.com/sites/ule/img/home/new/icon_gps.png")
        no-repeat center / 100% 100%;
      color: #117f06;
      text-align: center;
      padding-top: 6px;
    }
    ul {
      padding: 0 5px;
      li {
        color: #117f06;
        font-size: 14px;
        padding: 5px 0;
        text-align: center;
        &:nth-child(n + 2) {
          border-top: 1px solid #cdebcc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue